import React from 'react'
import ConditionalRender, {
  Experiment,
  Original
} from '@/components/ConditionalRender'
import { Booking } from './types'
import CrossSellDefault from './CrossSell'
import CrossSellVariant from './Experiments/CrossSell'

export default function CrossSell({ booking }: { booking: Booking }) {
  return (
    <ConditionalRender experimentCode="HP_XSELL_REDESIGN">
      <Original>
        <CrossSellDefault booking={booking} />
      </Original>
      <Experiment>
        <CrossSellVariant booking={booking} />
      </Experiment>
    </ConditionalRender>
  )
}
